module.exports = __webpack_public_path__ + "img/banner3.2c3f6ffc.png";